import axios from '@/assets/http';

export default {
    getRecommendList() {
        return axios.get(`/api/used/getRecommendList`);
    },
}
